import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=0ea8fffb"
import script from "./MenuButton.vue?vue&type=script&lang=js"
export * from "./MenuButton.vue?vue&type=script&lang=js"
import style0 from "./MenuButton.vue?vue&type=style&index=0&id=0ea8fffb&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ea8fffb')) {
      api.createRecord('0ea8fffb', component.options)
    } else {
      api.reload('0ea8fffb', component.options)
    }
    module.hot.accept("./MenuButton.vue?vue&type=template&id=0ea8fffb", function () {
      api.rerender('0ea8fffb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/MenuButton.vue"
export default component.exports